module.exports = __webpack_public_path__ + "Male_student.a06bbd5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/Male_student.png
// module id = X56S
// module chunks = 0